import { FC } from 'react';

import { Image } from 'src/general/components/Image/Image';
import { FinanceLogoIcon } from 'src/hygiene/templates/FinanceLogoIcon/FinanceLogoIcon';

type FinanceDescriptionContentProps = {
  sectionData: {
    title: string;
    subtitle: string;
    financeUSPs: {
      icon: string;
      description: string;
    }[];
    lenderIntro: string;
    lenders: {
      icon: string;
    }[];
  };
};

export const FinanceDescriptionContent: FC<FinanceDescriptionContentProps> = ({ sectionData }) => {
  return (
    <div className="py-6">
      <header className="mb-6 flex flex-col gap-2 sm:mb-8">
        <h2 className="c-fs-h4 font-extrabold">{sectionData.title}</h2>
        {sectionData.subtitle && <p className="c-fs-body2">{sectionData.subtitle}</p>}
      </header>
      <div className="mb-10 flex flex-col gap-6 smp:flex-row">
        {sectionData.financeUSPs.map((item) => (
          <div className="flex items-center gap-2 md:flex-col md:text-center" key={item.icon}>
            <Image src={item.icon} alt={item.description} width={40} height={40} />
            <span className="c-fs-body2">{item.description}</span>
          </div>
        ))}
      </div>

      <div className="md:flex md:items-stretch md:gap-4">
        <span className="sm:flex sm:items-center md:w-34">
          <p className="c-fs-body2">{sectionData.lenderIntro}</p>
        </span>
        <div className="hidden w-px bg-for-pri-bas sm:block" />
        <div className="mt-2 flex flex-wrap gap-2 sm:items-center">
          {sectionData.lenders.map((item) => (
            <div key={item.icon} className="flex h-8 w-23 items-end justify-center">
              <FinanceLogoIcon src={item.icon} alt={item.icon} width={92} height={32} />
            </div>
          ))}
        </div>
      </div>
      <div className="relative mt-24 hidden h-46 w-full md:block">
        <Image
          className="h-full w-full object-contain object-top-left"
          src="https://img.carma.com.au/ui-assets/FinanceHeroBanner/finance-car.png"
          width={453}
          height={184}
          alt="Tailored car finance that puts you in the driver’s seat."
        />
      </div>
    </div>
  );
};
